import { intl } from '@fullstory/intl';
export function getPercentString(numerator: number, denominator: number): string {
  const pct = (numerator * 100) / denominator;
  let pctString: string;
  if (pct < 0.1 && numerator > 0) {
    pctString = intl.formatMessage(
      {
        defaultMessage: '< {percent, number, ::percent .0}',
        id: 'n1Y1bZ',
        description: "'less than x percent'",
      },
      { percent: 0.001 },
    );
  } else if (pct > 99.9 && numerator != denominator) {
    pctString = intl.formatMessage(
      {
        defaultMessage: '> {percent, number, ::percent .0}',
        id: 'ABE20q',
        description: "'greater than x percent'",
      },
      { percent: 0.999 },
    );
  } else if (Number.isNaN(pct) || !Number.isFinite(pct)) {
    // Dividing by 0 gives us NaN or Infinity
    pctString = intl.formatNumber(0, { style: 'percent', minimumFractionDigits: 1 });
  } else {
    pctString = intl.formatNumber(pct / 100, { style: 'percent', minimumFractionDigits: 1 });
  }
  return pctString;
}
